import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "./RootNavigation";
import { useState } from "react";
import IconButton from "../components/IconButton";
import Modal from "../components/Modal";
import HStack from "../ui_atoms/HStack";
import ScreenTitle from "../components/ScreenTitle";
import { useNavigation } from "@react-navigation/native";
import { useIsScreenSizeMin } from "../hooks/useIsScreenSizeMin";

type ScreenParams = StackScreenProps<RootStackParamList>;

type ModalScreenWrapperProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    title?: string;
    fitContent?: boolean;
};

export const ModalScreenWrapper = ({
    component: Component,
    title,
    fitContent,
    ...props
}: ModalScreenWrapperProps) => {
    const isLarge = useIsScreenSizeMin("large");
    const [isVisible, setIsVisible] = useState(true);
    const navigation = useNavigation<ScreenParams["navigation"]>();

    if (!isLarge) {
        return <Component {...props} />;
    }

    return (
        <Modal fitContent={fitContent} visible={isVisible} hideContainerBackground>
            <HStack h="2/3" v={0.5} style={{ justifyContent: "space-between" }}>
                <ScreenTitle>{title}</ScreenTitle>
                <IconButton
                    testID="close-button"
                    onPress={() => {
                        navigation.goBack();
                        if (!navigation.isFocused()) {
                            setIsVisible(false);
                        }
                    }}
                    icon="close"
                    size={28}
                />
            </HStack>
            <Component {...props} />
        </Modal>
    );
};
